import { Tab, Tabs } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '@app/components/breadcrumbs/Breadcrumbs';
import { BREADCRUMB_IDS } from '@app/configs/breadcrumbs';
import { getDocumentsBorrower } from '@app/configs/documentsLists';
import { ROUTES } from '@app/configs/routes';
import { getUserLocale } from '@app/utils/getUserLocale';
import Documents from '@modules/borrower/components/loanDetails/Documents';
import LoanDetails from '@modules/borrower/components/loanDetails/LoanDetails';
const LoanDetailsPage = () => {
    const { t } = useTranslation();
    const locale = getUserLocale();
    const breadcrumbsItems = [
        { id: BREADCRUMB_IDS.LOAN_DETAILS, label: t('financing.breadcrumbs.details'), path: ROUTES.loanDetails },
    ];
    return (<div className="px-4 pb-4 md:px-6 md-pb-6 flex-col leading-5">
            <div className="pb-4 leading-5 font-medium">
                <Breadcrumbs items={breadcrumbsItems} activeBreadcrumb={BREADCRUMB_IDS.LOAN_DETAILS} type="borrower"/>
            </div>
            <h1 className="mt-4 mb-4 md:mb-6 font-bold text-2xl">{t('financing.loan_details.loan_details')}</h1>
            <Tabs defaultTab="summary">
                <Tab label={t('financing.loan_details.summary')} tabKey="summary">
                    <div className="flex flex-col gap-4">
                        <LoanDetails />
                    </div>
                </Tab>
                <Tab label={t('financing.loan_details.documents')} tabKey="documents">
                    <div className="flex flex-col gap-4">
                        <Documents documents={getDocumentsBorrower(locale)} isBorrower/>
                    </div>
                </Tab>
            </Tabs>
        </div>);
};
export default LoanDetailsPage;
